module.exports = __webpack_public_path__ + "img/product_128.50f076b.svg";